module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image9a.45752ce9.jpg";